import React, { useState, useEffect } from "react";
import { getBackendUrl } from "../env";
import { useDevicesContext } from "../hooks/useDevicesContext"
import { useAuthContext } from "../hooks/useAuthContext";
import DevicesDetails from "../components/DevicesDetails";
import ReactLoading from 'react-loading';
import DeviceForm from "../components/DeviceForm";
import OutletForm from "../components/OutletForm";
import { useLocation, useNavigate } from 'react-router-dom';
import { Device } from "../context/DeviceContext";
import { PlusCircle, RefreshCw, Plug } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import Select, { type SingleValue, type StylesConfig } from 'react-select'
import { hydroReactSelectStyles } from '@/lib/hydroReactSelectStyles'

type FilterOption = { value: string; label: string }

const DEVICE_FILTER_OPTIONS: FilterOption[] = [
    { value: 'all', label: 'All devices' },
    { value: 'all_sensors', label: 'Sensors' },
    { value: 'outlets', label: 'Outlets' },
    { value: 'connected', label: 'Connected' },
    { value: 'not_connected', label: 'Not connected' },
    { value: 'pH', label: 'pH sensor' },
    { value: 'EC', label: 'EC sensor' },
    { value: 'Temperature', label: 'Temperature sensor' },
    { value: 'Humidity', label: 'Humidity sensor' },
    { value: 'Pump', label: 'Pumps' },
    { value: 'Moisture', label: 'Moisture' },
    { value: 'TDS', label: 'TDS sensor' },
    { value: 'Water Flow Sensor', label: 'Water flow rate sensor' },
]

const deviceFilterStyles = hydroReactSelectStyles as StylesConfig<FilterOption, false>

const DeviceManager = () => {
    // const [devices, setDevices] = useState('')
    const [displayedDevices, setDisplayedDevices] = useState('')
    const [status, setStatus] = useState<string>('idle')
    const {devices, dispatch} = useDevicesContext()
    const {user} = useAuthContext()
    const [addDevicePopup, setAddDevicePopup] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)
    const [canAddDevice, setCanAddDevice] = useState<boolean>(user ? user.attemptingToAddDevice: false)
    const [deviceId, setDeviceId] = useState<string>('')
    const [newDevice, setNewDevice] = useState<boolean>(false)
    const [currentDevice, setDevice] = useState<Device | null>(null)
    const [outletPopup, setOutletPopup] = useState<boolean>(false)
    const [deviceFilter, setDeviceFilter] = useState<string>('all')
    const location = useLocation();
    const navigate = useNavigate();

  const getNewestDevice = async () => {
    if(user){
      const response = await fetch(`${getBackendUrl()}/api/devices/newest`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${user.token}`
        }
      })
      const json = await response.json()
      if (!response.ok) {
        console.log("test11111")
        setError(json.error)
      }
      if (response.ok) {
        console.log(json)
        setDevice(json)
        setAddDevicePopup(true)
        setNewDevice(true)
        
      } 
    }
  }


    
  //Makes call to backend to change the status of attemptingToAddDevice to false
    const setAttemptingToAddDevice = async () => {
      if(user){
        setCanAddDevice(false)
        user.attemptingToAddDevice = false
        user.is_outlet = false
        user.device_to_add = " "

        const response = await fetch(`${getBackendUrl()}/api/user/` +user.user_id, {
          method: 'PATCH',
          body: JSON.stringify(user),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user.token}`
          }
        })
        const json = await response.json()
        console.log("json: ", json)
        if (!response.ok) {
          setError(json.error)
          user.attemptingToAddDevice = false
          user.is_outlet = false
          setCanAddDevice(false)
        }
        if (response.ok) {
          localStorage.setItem('user', JSON.stringify(user))
          console.log("added device")
          setCanAddDevice(false)
        }
      }
    }
 
    //Function is called after device controller has had a chance to connect a new device
    const addingDeviceResponseHandler = async () =>{
      if(user){
        // Get updated user from db to see if message has been updated
        const response1 = await fetch(`${getBackendUrl()}/api/user/` +user.user_id, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user.token}`
          }
        })
        const json1 = await response1.json()
        if (!response1.ok) {
          setError(json1.error)
          setAttemptingToAddDevice()
        }
        if (response1.ok){
          console.log("json1", json1)
          //The below line may be needed!!!
          // dispatchUser({type: 'UPDATE', payload: json1})
          setAttemptingToAddDevice()
          if (json1.message === "New device has connected"){
            getNewestDevice() 
          }
          
        }

        if (json1.message == ''){
          alert("No new devices found")
        }
        else{
          console.log(json1.message)
          alert(json1.message)
        }
        
        user.message = ""
        // Resetting the user message attribute in the DB 
        const response2 = await fetch(`${getBackendUrl()}/api/user/` +user.user_id, {
          method: 'PATCH',
          body: JSON.stringify(user),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user.token}`
          }
        })
        const json2 = await response2.json()

        if (!response2.ok) {
          setError(json2.error)
        }
        if (response2.ok){
          console.log(json2)  
        }      
        }
    }

    //Makes call to backend to change the status of attemptingToAddDevice to true
    const addDeviceHandler = async () => {
        if (!user) {
        setError('You must be logged in')
        return
      }    
      setCanAddDevice(true)
      user.attemptingToAddDevice = true
      console.log(user.attemptingToAddDevice)
      const response = await fetch(`${getBackendUrl()}/api/user/` +user.user_id, {
        method: 'PATCH',
        body: JSON.stringify(user),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${user.token}`
        }
      })
      const json = await response.json()
      console.log("json: ", json)
      if (!response.ok) {
        setError(json.error)
        user.attemptingToAddDevice = false
        user.is_outlet = false
        setCanAddDevice(false)
      }
      if (response.ok) {
        console.log('test', json)
        setCanAddDevice(user.attemptingToAddDevice)
        localStorage.setItem('user', JSON.stringify(user))
        if (user.attemptingToAddDevice == true){
          console.log(user.token)
          setStatus('pending')
          setTimeout(
            function(){
            addingDeviceResponseHandler()
            setStatus('resolved')
          }.bind(this), 10000);
        }
        
      }
    }

    const addOutletHandler = async () =>{
      console.log("hehheheheheehh")
      console.log(user)
      if(user && !user.device_credentials['Etekcity']){
        console.log("clicked and here")
        setOutletPopup(true)
      }
      
    }


    const updateUserInfo = async () => {
      if(user){
        const response = await fetch(`${getBackendUrl()}/api/user/` +user.user_id, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user.token}`
          }
        })
        const json = await response.json()
        if (response.ok){
          setCanAddDevice(user.attemptingToAddDevice)
        }
      }
    }
    useEffect(()=>{
      updateUserInfo()
    }, [])

    const refreshPage = () => {
      navigate(location.pathname);
        setStatus('pending')
        // console.log("tests")
        if (user) {
          fetchDevices()
        }
    }

    useEffect(() => {
      const intervalId = setInterval(() => {
        navigate(location.pathname);
        setStatus('pending')
        // console.log("tests")
        if (user) {
          fetchDevices()
        }
      }, 60000);
      return () => clearInterval(intervalId);
    }, [location, navigate]);

    const fetchDevices = async () => {
      if(user){
        const response = await fetch(`${getBackendUrl()}/api/devices`, {
          headers: {'Authorization': `Bearer ${user.token}`},
        })
        const json = await response.json()

        if (response.ok) {
          dispatch({type: 'SET_DEVICES', payload: json})
          setStatus('resolved')
        }
      }
    }

    useEffect(() => {
        setStatus('pending')
        if (user) {
          fetchDevices()
        }
      }, [dispatch, user])


    return ( 
        <>
        <header
            className={cn(
                'device-toolbar !grid !h-auto w-full min-w-0 shrink-0 grid-cols-2 items-center gap-x-2 gap-y-3 overflow-visible border-b border-zinc-800/90 bg-zinc-900/95 px-3 py-3.5 shadow-sm backdrop-blur-sm supports-[backdrop-filter]:bg-zinc-900/80 sm:!flex sm:min-h-[4.75rem] sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-3 sm:gap-y-2 sm:px-5 sm:py-4'
            )}
            aria-label="Devices toolbar"
        >
            <span className="col-span-2 flex w-full flex-col items-center justify-center text-center text-xs font-semibold uppercase tracking-wide text-zinc-400 sm:col-auto sm:mr-auto sm:w-auto sm:items-start sm:justify-start sm:text-left sm:text-sm">
                Devices
            </span>
            <Button
                type="button"
                disabled={canAddDevice === true}
                onClick={() => {
                    if (canAddDevice === false) addDeviceHandler()
                }}
                className="h-10 min-h-10 w-full min-w-0 justify-center gap-2 bg-emerald-600 px-2 text-sm font-semibold text-white shadow hover:bg-emerald-500 sm:w-auto sm:shrink-0 sm:px-4"
            >
                <PlusCircle className="size-4 shrink-0" aria-hidden />
                <span className="truncate">Add device</span>
            </Button>
            <Button
                type="button"
                variant="outline"
                onClick={() => refreshPage()}
                className="h-10 min-h-10 w-full min-w-0 justify-center gap-2 border-zinc-600 bg-zinc-950/60 px-2 text-sm text-zinc-100 shadow-sm hover:bg-zinc-800 hover:text-white sm:w-auto sm:shrink-0 sm:px-4"
            >
                <RefreshCw className="size-4 shrink-0" aria-hidden />
                <span className="truncate">Refresh</span>
            </Button>
            <Button
                type="button"
                variant="outline"
                disabled={canAddDevice === true}
                onClick={() => {
                    if (canAddDevice === false) addOutletHandler()
                }}
                className="col-span-2 h-10 min-h-10 w-full min-w-0 justify-center gap-2 border-zinc-600 bg-zinc-950/60 px-2 text-sm text-zinc-100 shadow-sm hover:bg-zinc-800 hover:text-white sm:col-span-1 sm:w-auto sm:shrink-0 sm:px-4"
            >
                <Plug className="size-4 shrink-0" aria-hidden />
                <span className="truncate">Add outlet</span>
            </Button>
        </header>
        {/* Filter lives outside the blurred header so native / portaled menus aren’t offset (stacking context). */}
        <div className="w-full shrink-0 border-b border-zinc-800/90 bg-zinc-900/95 px-3 py-3 sm:px-5">
            <div className="mx-auto flex w-full max-w-6xl flex-col gap-2 sm:flex-row sm:items-end sm:justify-between sm:gap-4">
                <span className="text-xs font-medium uppercase tracking-wide text-zinc-500">Filter devices</span>
                <div className="relative z-10 min-h-[44px] w-full min-w-0 sm:max-w-sm">
                    <Select<FilterOption, false>
                        instanceId="device-manager-filter"
                        inputId="device-manager-filter-input"
                        classNamePrefix="hydro-device-filter"
                        options={DEVICE_FILTER_OPTIONS}
                        value={
                            DEVICE_FILTER_OPTIONS.find((o) => o.value === deviceFilter) ??
                            DEVICE_FILTER_OPTIONS[0]
                        }
                        onChange={(opt: SingleValue<FilterOption>) => {
                            if (opt) setDeviceFilter(opt.value)
                        }}
                        styles={deviceFilterStyles}
                        menuPortalTarget={
                            typeof document !== 'undefined' ? document.body : undefined
                        }
                        menuPosition="fixed"
                        menuPlacement="auto"
                        isSearchable={false}
                        blurInputOnSelect
                        aria-label="Filter devices"
                    />
                </div>
            </div>
        </div>
        <div className="mx-auto w-full max-w-6xl flex-1 px-2 pb-8 pt-2 sm:px-4">
          {(status === 'idle' || status ==='pending') &&
            <div className="flex min-h-[30vh] w-full flex-col items-center justify-center gap-3 text-zinc-400">
              <span className="text-sm">Loading devices…</span>
              <ReactLoading type={"spin"} color={"#2596be"}/>
            </div>
          
          }
        {status === 'resolved' && (
          <div className="flex w-full flex-col flex-wrap gap-4 py-2 sm:flex-row sm:items-stretch sm:justify-center">
            {devices && 
                devices.map((device) => {
                  if(deviceFilter === 'all'){
                    return <DevicesDetails setAddDevicePopup={setAddDevicePopup} setNewDevice={setNewDevice} setDevice={setDevice} key={device._id} device={device}/>
                  }
                  else if (deviceFilter === 'all_sensors' && !device.device_type.includes('Outlet') && !device.device_type.includes('Pump')){
                    return <DevicesDetails setAddDevicePopup={setAddDevicePopup} setNewDevice={setNewDevice} setDevice={setDevice} key={device._id} device={device}/>
                  }
                  else if (deviceFilter === 'outlets' && device.device_type.includes('Outlet')){
                    return <DevicesDetails setAddDevicePopup={setAddDevicePopup} setNewDevice={setNewDevice} setDevice={setDevice} key={device._id} device={device}/>
                  }
                  else if (deviceFilter === 'connected' && device.connected === true){
                    return <DevicesDetails setAddDevicePopup={setAddDevicePopup} setNewDevice={setNewDevice} setDevice={setDevice} key={device._id} device={device}/>
                  }
                  else if (deviceFilter === 'not_connected' && device.connected === false){
                    return <DevicesDetails setAddDevicePopup={setAddDevicePopup} setNewDevice={setNewDevice} setDevice={setDevice} key={device._id} device={device}/>
                  }
                  else if (deviceFilter === 'pH' && device.device_type.includes('pH')){
                    return <DevicesDetails setAddDevicePopup={setAddDevicePopup} setNewDevice={setNewDevice} setDevice={setDevice} key={device._id} device={device}/>
                  }
                  else if (deviceFilter === 'EC' && device.device_type.includes('EC')){
                    return <DevicesDetails setAddDevicePopup={setAddDevicePopup} setNewDevice={setNewDevice} setDevice={setDevice} key={device._id} device={device}/>
                  }
                  else if (deviceFilter === 'Temperature' && device.device_type.includes('Temperature')){
                    return <DevicesDetails setAddDevicePopup={setAddDevicePopup} setNewDevice={setNewDevice} setDevice={setDevice} key={device._id} device={device}/>
                  }
                  else if (deviceFilter === 'Humidity' && device.device_type.includes('Humidity')){
                    return <DevicesDetails setAddDevicePopup={setAddDevicePopup} setNewDevice={setNewDevice} setDevice={setDevice} key={device._id} device={device}/>
                  }
                  else if (deviceFilter === 'Pump' && device.device_type.includes('Pump')){
                    return <DevicesDetails setAddDevicePopup={setAddDevicePopup} setNewDevice={setNewDevice} setDevice={setDevice} key={device._id} device={device}/>
                  }
                  else if (deviceFilter === 'Moisture' && device.device_type.includes('Moisture')){
                    return <DevicesDetails setAddDevicePopup={setAddDevicePopup} setNewDevice={setNewDevice} setDevice={setDevice} key={device._id} device={device}/>
                  }
                  else if (deviceFilter === 'TDS' && device.device_type.includes('TDS')){
                    return <DevicesDetails setAddDevicePopup={setAddDevicePopup} setNewDevice={setNewDevice} setDevice={setDevice} key={device._id} device={device}/>
                  }
                  else if (deviceFilter === 'Water Flow Sensor' && device.device_type.includes('Water Flow Rate')){
                    return <DevicesDetails setAddDevicePopup={setAddDevicePopup} setNewDevice={setNewDevice} setDevice={setDevice} key={device._id} device={device}/>
                  }
                  else{
                    return null
                  }
                  
                }
            )}
            
            {!devices && (
              <div className="mx-auto flex min-h-[40vh] w-full flex-col items-center justify-center text-zinc-400">
                  <h3 className="text-lg font-medium text-zinc-300">No devices found</h3>
              </div>
            )}
          </div>
        )}
        {currentDevice!==null &&<DeviceForm trigger={addDevicePopup} setDevice={setDevice} device={currentDevice} newDevice={newDevice} setAddDevicePopup={setAddDevicePopup}/>}
        <OutletForm trigger={outletPopup} setOutletPopup={setOutletPopup} addDeviceHandler={addDeviceHandler}/>
        </div>
        </>
     );
}
 


export default DeviceManager;